import React, { useState } from "react";
//common
import Card from "../../components/mui/Card";
import CardContent from "../../components/mui/CardContent";
import Typography from "../../components/mui/Typography";
import Button from "../../components/mui/Button";
import Box from "../../components/mui/Box";
import { BorderColor } from "@mui/icons-material";
import styled from "@emotion/styled";

interface TierProps {
  tier: string;
  data: { rank: number; centerName: string; description: string }[];
  getTierColor: string;
  handleButtonClick: any;
}
const Cards: React.FC<TierProps> = ({ tier, data, handleButtonClick }) => {
  const getTierColor = (tier: string) => {
    switch (tier) {
      case "GOLD":
        return "#FFF1B7";
      case "PLATINUM":
        return "#E1E1E1";
      case "SILVER":
        return "#F6F1FF";
      case "BRONZE":
        return "#f9c189";
      default:
        return "#FCFFC1";
    }
  };

  return (
    <Card
      sx={{
        mb: 2,
        borderRadius: "9px",
        border: "1px solid #D0D0D0",
        // marginTop: tier === "GOLD" ? "-22px" : "0px",
        zIndex: tier === "GOLD" ? 1 : 0,
        position: tier === "GOLD" ? "relative" : "static",
        boxShadow: "none",
      }}
    >
      <CardContent sx={{ padding: "25px  30px" }}>
        <Typography
          variant="h5"
          sx={{
            textTransform: "capitalize",
            mb: 2,
            backgroundColor: getTierColor(tier),
            borderRadius: "8px",
            padding: "8px 18px",
            fontWeight: "600",
            fontSize: "15px",
            color: "#101828",
            lineHeight: "25px",
          }}
        >
          {tier}
        </Typography>
        <ScrollableList>
          {data.map((item) => (
            <>
              <li key={item.rank}>
                <Typography
                  sx={{
                    mb: 1,
                    fontWeight: "400",
                    fontSize: "13px",
                    color: "#262626",
                    lineHeight: "20px",
                  }}
                >
                  {item.rank}. {item?.centerName}
                </Typography>
                <hr style={{ border: "1px solid #DCDCDC" }}></hr>
              </li>
            </>
          ))}
        </ScrollableList>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button
            sx={{
              background: "#FFF1B7",
              color: "#242424",
              fontWeight: "600",
              fontSize: "12px",
              padding: "7px 106px",
              borderRadius: "6px",
              border: "1px solid #997906",
              boxShadow: "none",
              width: "100%",
              textTransform: "capitalize",
              "&:hover": {
                boxShadow: "none",
              },
            }}
            onClick={() => handleButtonClick()}
          >
            View Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

const ScrollableList = styled("ul")({
  paddingLeft: 0,
  listStyle: "none",
  height: "350px",
  overflowY: "auto",
  overflowX: "hidden",
  scrollbarWidth: "thin",
});

export default Cards;
